import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Select from '../../../../../components/Select/index';
import 'parsleyjs';

class StateForm extends Component {
    updateAddNewStateData = state => {
        let { updateStateData } = this.props;
        updateStateData(state);
    };

    handleInputChange = event => {
        let { stateData, isEditable } = this.props;
        if (isEditable) {
            const target = event.target;
            const value =
                target.type === 'checkbox' ? target.checked : target.value;
            const name = target.name;

            let tmpSelected = _.extend({}, stateData);
            tmpSelected[name] = value;
            this.updateAddNewStateData(tmpSelected);
        }
    };

    handleSelectChange = (name, value, valueKey) => {
        let { stateData } = this.props;
        let tmpSelected = _.extend({}, stateData);
        if (value !== null) {
            if (valueKey) {
                tmpSelected[name] = value[valueKey];
            } else {
                tmpSelected[name] = value[name];
            }
        } else {
            tmpSelected[name] = '';
        }
        this.updateAddNewStateData(tmpSelected);
    };

    render() {
        let { 
            stateData, 
            isEditable, 
            fundFilingTypes, 
            renewalCycleTypes, 
            paymentTypes, 
            permitNumberTypes, 
            formRef 
        } = this.props;
        return (
            <form ref={formRef}>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Name</label>
                        <input
                            className="form-control"
                            type="text"
                            name="name"
                            value={stateData.name}
                            onChange={this.handleInputChange}
                            disabled={true}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Code</label>
                        <input
                            className="form-control"
                            type="text"
                            name="code"
                            value={stateData.code}
                            onChange={this.handleInputChange}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Has Initial Nf Form</label>
                        <Select
                            labelKey="name"
                            valueKey="hasInitialNfForm"
                            name="hasInitialNfForm"
                            selectedValue={stateData.hasInitialNfForm}
                            onChange={this.handleSelectChange}
                            options={[
                                {
                                    name: 'Yes',
                                    hasInitialNfForm: true
                                },
                                {
                                    name: 'No',
                                    hasInitialNfForm: false
                                }
                            ]}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Has Renewal Nf Form</label>
                        <Select
                            labelKey="name"
                            valueKey="hasRenewalNfForm"
                            name="hasRenewalNfForm"
                            selectedValue={stateData.hasRenewalNfForm}
                            onChange={this.handleSelectChange}
                            options={[
                                {
                                    name: 'Yes',
                                    hasRenewalNfForm: true
                                },
                                {
                                    name: 'No',
                                    hasRenewalNfForm: false
                                }
                            ]}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Has Amendment Nf Form</label>
                        <Select
                            labelKey="name"
                            valueKey="hasAmendmentNfForm"
                            name="hasAmendmentNfForm"
                            selectedValue={stateData.hasAmendmentNfForm}
                            onChange={this.handleSelectChange}
                            options={[
                                {
                                    name: 'Yes',
                                    hasAmendmentNfForm: true
                                },
                                {
                                    name: 'No',
                                    hasAmendmentNfForm: false
                                }
                            ]}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Has Termination Nf Form</label>
                        <Select
                            labelKey="name"
                            valueKey="hasTerminationNfForm"
                            name="hasTerminationNfForm"
                            selectedValue={stateData.hasTerminationNfForm}
                            onChange={this.handleSelectChange}
                            options={[
                                {
                                    name: 'Yes',
                                    hasTerminationNfForm: true
                                },
                                {
                                    name: 'No',
                                    hasTerminationNfForm: false
                                }
                            ]}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Has Initial U2 Form</label>
                        <Select
                            labelKey="name"
                            valueKey="hasInitialU2Form"
                            name="hasInitialU2Form"
                            selectedValue={stateData.hasInitialU2Form}
                            onChange={this.handleSelectChange}
                            options={[
                                {
                                    name: 'Yes',
                                    hasInitialU2Form: true
                                },
                                {
                                    name: 'No',
                                    hasInitialU2Form: false
                                }
                            ]}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Has Renewal U2 Form</label>
                        <Select
                            labelKey="name"
                            valueKey="hasRenewalU2Form"
                            name="hasRenewalU2Form"
                            selectedValue={stateData.hasRenewalU2Form}
                            onChange={this.handleSelectChange}
                            options={[
                                {
                                    name: 'Yes',
                                    hasRenewalU2Form: true
                                },
                                {
                                    name: 'No',
                                    hasRenewalU2Form: false
                                }
                            ]}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Has Amendment U2 Form</label>
                        <Select
                            labelKey="name"
                            valueKey="hasAmendmentU2Form"
                            name="hasAmendmentU2Form"
                            selectedValue={stateData.hasAmendmentU2Form}
                            onChange={this.handleSelectChange}
                            options={[
                                {
                                    name: 'Yes',
                                    hasAmendmentU2Form: true
                                },
                                {
                                    name: 'No',
                                    hasAmendmentU2Form: false
                                }
                            ]}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Has Termination U2 Form</label>
                        <Select
                            labelKey="name"
                            valueKey="hasTerminationU2Form"
                            name="hasTerminationU2Form"
                            selectedValue={stateData.hasTerminationU2Form}
                            onChange={this.handleSelectChange}
                            options={[
                                {
                                    name: 'Yes',
                                    hasTerminationU2Form: true
                                },
                                {
                                    name: 'No',
                                    hasTerminationU2Form: false
                                }
                            ]}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Is Electronic Filing</label>
                        <Select
                            labelKey="name"
                            valueKey="isElectronicFiling"
                            name="isElectronicFiling"
                            selectedValue={stateData.isElectronicFiling}
                            onChange={this.handleSelectChange}
                            options={[
                                {
                                    name: 'Yes',
                                    isElectronicFiling: true
                                },
                                {
                                    name: 'No',
                                    isElectronicFiling: false
                                }
                            ]}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Renewal Cycle Type</label>
                        <Select
                            labelKey="enumName"
                            valueKey="enumId"
                            name="renewalCycleType"
                            selectedValue={stateData.renewalCycleType}
                            onChange={this.handleSelectChange}
                            options={renewalCycleTypes}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Payment Type</label>
                        <Select
                            labelKey="enumName"
                            valueKey="enumId"
                            name="paymentType"
                            selectedValue={stateData.paymentType}
                            onChange={this.handleSelectChange}
                            options={paymentTypes}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Filing Type</label>
                        <Select
                            labelKey="enumName"
                            valueKey="enumId"
                            name="fundFilingType"
                            selectedValue={stateData.fundFilingType}
                            onChange={this.handleSelectChange}
                            options={fundFilingTypes}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Bulk Checks Permitted</label>
                        <Select
                            labelKey="name"
                            valueKey="bulkChecksPermitted"
                            name="bulkChecksPermitted"
                            selectedValue={stateData.bulkChecksPermitted}
                            onChange={this.handleSelectChange}
                            options={[
                                {
                                    name: 'Yes',
                                    bulkChecksPermitted: true
                                },
                                {
                                    name: 'No',
                                    bulkChecksPermitted: false
                                }
                            ]}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Permit Number Type</label>
                        <Select
                            labelKey="enumName"
                            valueKey="enumId"
                            name="permitNumberType"
                            selectedValue={stateData.permitNumberType}
                            onChange={this.handleSelectChange}
                            options={permitNumberTypes}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Need Sales Reports</label>
                        <Select
                            labelKey="name"
                            valueKey="needSalesReports"
                            name="needSalesReports"
                            selectedValue={stateData.needSalesReports}
                            onChange={this.handleSelectChange}
                            options={[
                                {
                                    name: 'Yes',
                                    needSalesReports: true
                                },
                                {
                                    name: 'No',
                                    needSalesReports: false
                                }
                            ]}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Check Payee</label>
                        <input
                            className="form-control"
                            type="text"
                            name="checkPayee"
                            value={stateData.checkPayee}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>File By Days</label>
                        <input
                            className="form-control"
                            type="text"
                            name="fileByDays"
                            value={stateData.fileByDays}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Sales Report By Days</label>
                        <input
                            className="form-control"
                            type="text"
                            name="salesReportByDays"
                            value={stateData.salesReportByDays}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>State Filing Status</label>
                        <input
                            className="form-control"
                            type="text"
                            name="stateFilingStatus"
                            value={stateData.stateFilingStatus}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Termination Fee</label>
                        <input
                            className="form-control"
                            type="text"
                            name="terminationFee"
                            value={stateData.terminationFee}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Initial Fee Calculation Type</label>
                        <input
                            className="form-control"
                            type="text"
                            name="initialFeeCalculationType"
                            value={stateData.initialFeeCalculationType}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Renewal Fee Calculation Type</label>
                        <input
                            className="form-control"
                            type="text"
                            name="renewalFeeCalculationType"
                            value={stateData.renewalFeeCalculationType}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Initial Fee Calculation Type Parameters</label>
                        <input
                            className="form-control"
                            type="text"
                            name="initialFeeCalculationTypeParameters"
                            value={
                                stateData.initialFeeCalculationTypeParameters
                            }
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Renewal Fee Calculation Type Parameters</label>
                        <input
                            className="form-control"
                            type="text"
                            name="renewalFeeCalculationTypeParameters"
                            value={
                                stateData.renewalFeeCalculationTypeParameters
                            }
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Minimum Fee</label>
                        <input
                            className="form-control"
                            type="text"
                            name="minimumFee"
                            value={stateData.minimumFee}
                            onChange={this.handleInputChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

StateForm.propTypes = {
    stateData: PropTypes.object.isRequired,
    fundFilingTypes: PropTypes.array.isRequired,
    renewalCycleTypes: PropTypes.array.isRequired,
    paymentTypes: PropTypes.array.isRequired,
    permitNumberTypes: PropTypes.array.isRequired,
    updateStateData: PropTypes.func,
    isEditable: PropTypes.func.bool
};

StateForm.defaultProps = {
    isEditable: true
};

export default StateForm;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ManageStates/components/StateForm.js